import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;

$.setBreadcrumb = (name, value) => {
  const $crumbs = $('.breadcrumbs');
  const $back = $('.btn-back-to-parent');

  for (const crumb of $crumbs.children()) {
    const $crumb = $(crumb);
    const uri = $crumb.attr('href');

    if (uri && uri.indexOf(`:${name}`) >= 0) {
      if (value.id >= 0) $crumb.attr('href', uri.replace(`:${name}`, value.id));
      else $crumb.removeAttr('href');
    }

    /* prettier-ignore */
    if ($crumb.is(`[name="${name}"]`)) {
      $crumb.addClass('font-weight-bolder').empty();

      if (typeof value === 'string') $crumb.append(value);
      else {
        if (value.id) $crumb.append(`<span class="badge badge-primary" data-copyable data-content="${value.id}">ID ${value.id}</span>`);
        if (value.sales_code) $crumb.append(`<span class="badge badge-success">AC ${value.sales_code}</span>`);
        if (value.username) $crumb.append(`<span class="badge badge-success">${value.username}</span>`);
        if (value.lot_number) $crumb.append(`<span class="badge badge-success">${W.AUTH.website.id}-${value.lot_number}</span>`);
        if (value.product_number) $crumb.append(`<span class="badge badge-success">${W.AUTH.website.id}-${value.product_number}</span>`);
        if (value.listing_number) $crumb.append(`<span class="badge badge-success">${W.AUTH.website.id}-${value.listing_number}</span>`);
        if (value.name) $crumb.append(Utils.truncate(value.name, { length: 80, separator: ' ' }));
      }

      $crumb.initUI('tooltip');
    }
  }

  if ($back.length && Utils.isObject(value)) {
    const uri = $back.attr('href');
    if (uri && uri.indexOf(`:${name}`) >= 0 && value.id >= 0) $back.attr('href', uri.replace(`:${name}`, value.id));
  }

  $crumbs.removeClass('invisible');
};
